import { StatusIndicatorLevel } from '@aus-platform/design-system';
import type { ImageryLayer, ImageryLayerFeatureInfo } from 'cesium';
import { isEmpty, isNil } from 'lodash';
import type { WorkspaceLayer } from 'map-3d/components/map-3d-sidebar/shared';
import { canShowHistogramLayerTypesList } from '../../shared';

export const canLayerShowHistogram = (layer: WorkspaceLayer): boolean =>
  canShowHistogramLayerTypesList.includes(layer.type);

export const isLayerProcessing = (layer: WorkspaceLayer): boolean =>
  !isNil(layer.layerStatus) &&
  layer.layerStatus !== StatusIndicatorLevel.Done &&
  layer.layerStatus !== StatusIndicatorLevel.Completed;

export const isLayerPresentOnMap = (layer: WorkspaceLayer): boolean =>
  !isNil(layer.mapLayer) || !isEmpty(layer.features);


/**
 * Resolves the id of the picked MVT feature belonging to the layer being
 * edited. `pickImageryLayerFeatures` returns hits top-down, so at an overlap
 * the first one belongs to whichever layer renders on top — restrict to
 * `activeImageryLayer`, or take the first hit when there is none.
 */
export const resolveActiveLayerFeatureId = (
  features: ImageryLayerFeatureInfo[],
  activeImageryLayer?: ImageryLayer,
): string | null => {
  const candidates = isNil(activeImageryLayer)
    ? features
    : features.filter((feature) => feature.imageryLayer === activeImageryLayer);

  for (const candidate of candidates) {
    const [sourceLayerName] = Object.keys(candidate.data ?? {});

    if (isNil(sourceLayerName)) {
      continue;
    }

    const featureId = candidate.data[sourceLayerName]?.[0]?.id;

    if (!isNil(featureId)) {
      return String(featureId);
    }
  }

  return null;
};
